import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationLanguages } from 'src/app/components/language/language';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-account-created',
    templateUrl: './account-created.component.html',
    styleUrls: ['./account-created.component.scss'],
    standalone: false
})
export class AccountCreatedComponent implements OnInit {

  programName:string='BounceBack';
  llttfpage:boolean=false;
  translations: Record<string, string> = {};
  accountCreatedBody = '';

  constructor(
    private route:ActivatedRoute,
    private translationService: TranslationService,
    private languageService: LanguageService
  ){}

  ngOnInit()
  {
    this.route.params.subscribe(params => {
      this.llttfpage = params['programname'] == 'llttf';
      this.refreshProgramName();
      this.refreshBody();
    });

    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
        this.refreshProgramName();
        this.refreshBody();
      }
    });
  }

  private refreshProgramName(): void {
    const french = this.languageService.getCurretnLang() === ApplicationLanguages.FRENCH
      || this.languageService.isFrenchHost();
    if (this.llttfpage) {
      this.programName = french ? 'Vivre la vie pleinement' : 'Living Life to the Full';
    } else {
      this.programName = french ? 'Retrouver son entrain' : 'BounceBack';
    }
  }

  private refreshBody(): void {
    const template = this.translations['sgpAccountCreatedBody']
      ?? 'Your account has been successfully created! Please log in using your email address and password to access the {{programName}} Program.';
    this.accountCreatedBody = template.replace('{{programName}}', this.programName);
  }

}
